<ul class="nav nav-tabs">
  <ng-content select="li[ap-nav-bar-tab]"></ng-content>
</ul>
